var exports = {
  "k": "EmojiUploadModal.module__container___eUZMVl",
  "i": "EmojiUploadModal.module__message___eUZMVl",
};

module.exports = exports;
